import { io } from 'socket.io-client';
import { getVendorToken } from '../context/AuthContext';

let socket;

export const connectSocket = (vendorId) => {
  const token = getVendorToken();
  socket = io(process.env.REACT_APP_SOCKET_URL || 'http://localhost:4000', {
    auth: token ? { token } : {},
    withCredentials: true,
  });

  socket.on('connect', () => {
    console.log('📡 Socket connected');
    if (vendorId) socket.emit('join:vendor', vendorId);
  });

  return socket;
};

export const getSocket = () => socket;

export const disconnectSocket = () => {
  if (socket) socket.disconnect();
};
